var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12.75C3 8.27166 3 6.03249 4.39124 4.64124C5.78249 3.25 8.02166 3.25 12.5 3.25C16.9783 3.25 19.2175 3.25 20.6088 4.64124C22 6.03249 22 8.27166 22 12.75C22 17.2283 22 19.4675 20.6088 20.8588C19.2175 22.25 16.9783 22.25 12.5 22.25C8.02166 22.25 5.78249 22.25 4.39124 20.8588C3 19.4675 3 17.2283 3 12.75Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17 9.75C17.8284 9.75 18.5 9.07843 18.5 8.25C18.5 7.42157 17.8284 6.75 17 6.75C16.1716 6.75 15.5 7.42157 15.5 8.25C15.5 9.07843 16.1716 9.75 17 9.75Z",
    stroke: "black",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 22.75C15.8805 20.5249 14.4345 18.5321 12.3765 17.0842C10.1576 15.5229 7.37163 14.6966 4.51569 14.7527C4.17658 14.7519 3.83776 14.7627 3.5 14.7851",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 18.75C15.2015 17.4233 17.0345 16.7428 18.8862 16.7501C19.9362 16.749 20.9812 16.9716 22 17.4117",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/image.255e5755a2ced5764089ca5cca191910.svg";
export { ForwardRef as ReactComponent };